module.exports = __webpack_public_path__ + "img/tornilleria.6f64efb2.jpg";